import React, { useState } from "react";
import AuthLayout from "../../../shared/Layouts/AuthLayout";
import { CUSTOMARY_LOGO } from "../../../assets";
import { useAppDispatch } from "../../../hooks";
import { setRole } from "../../../states/slices/authReducer";
import { useNavigate } from "react-router-dom";
import { handleNavigate } from "../../../utils";

function Login() {
  const dispatch = useAppDispatch();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState();
  const navigate = useNavigate();
  const handleLogin = () => {
    if (!email) return;
    dispatch(setRole(email));

    handleNavigate(email, navigate);
  };
  return (
    <AuthLayout>
      <div className="flex w-[400px] flex-col gap-y-4">
        <img src={CUSTOMARY_LOGO} className="w-[64px] h-[64px]" alt="" />

        <div className="flex flex-col items-start w-full">
          <span className="text-[#232E35] text-[32px] font-bold ">Login</span>
          <span className="text-[#515457] text-[16px] font-medium ">
            Welcome back, Please login here.
          </span>
        </div>
        <div className="w-full flex flex-col gap-y-2 items-start">
          <div className="flex flex-col gap-y-1 w-full">
            <label htmlFor="email" className="text-[16px] font-medium">
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-5 py-3 outline-none border border-[#EDEDED]  placeholder:text-[#C1CAD0] text-[#515457] rounded-3xl"
              placeholder="Enter your email"
            />
          </div>
          <div className="flex flex-col gap-y-1 w-full">
            <label
              htmlFor="password"
              className="text-[16px] outline-none font-medium"
            >
              Password
            </label>
            <input
              type="password"
              className="w-full px-5 py-3 border text-[15px] outline-none border-[#EDEDED]  placeholder:text-[#C1CAD0] text-[#515457] rounded-3xl"
              placeholder="Enter your password"
            />
          </div>
          <button className="flex text-sm font-medium self-end text-[#217834]">
            Forgot password?
          </button>
        </div>
        <button
          onClick={handleLogin}
          className="w-full px-5 py-3 bg-[#217834] text-white text-[16px] font-medium rounded-3xl"
        >
          Login
        </button>
      </div>
    </AuthLayout>
  );
}

export default Login;
